import { useEffect } from "react";
import s from "./TemplateOriginal.module.css";
import {
  getBannerMode,
  getBackground,
  getCoverImageWrapperStyle,
  getResolvedCoverImageUrl,
  hasAddressContent,
} from "../../../utils/layoutUtils";
import EventAddressLink from "../../../components/EventAddressLink";

function AddressLinkOriginal(props) {
  return (
    <EventAddressLink
      {...props}
      color="white"
      fontWeight={600}
      fontSize="1em"
      iconSize={24}
      pinSize={60}
      pinRadius={15}
      defaultMode="pin"
      defaultAlign="center"
      defaultPinBorderMode="default"
      style={{ margin: "0 0 20px" }}
      textStyle={{ textShadow: "1px 1px 2px rgba(0,0,0,0.3)" }}
      placeStyle={{ textShadow: "1px 1px 2px rgba(0,0,0,0.3)" }}
    />
  );
}

export default function TemplateOriginal({ evento, children, layoutConfig }) {
  const data = new Date(evento.dataDoEvento);
  const dia = data.toLocaleDateString("pt-BR", { day: "2-digit", timeZone: "America/Sao_Paulo" });
  const mes = data.toLocaleDateString("pt-BR", { month: "long", timeZone: "America/Sao_Paulo" });
  const diaSemana = data.toLocaleDateString("pt-BR", { weekday: "long", timeZone: "America/Sao_Paulo" });
  const hora = data.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", timeZone: "America/Sao_Paulo" });

  const mapsUrl =
    evento.mapaUrl ||
    `https://maps.google.com/?q=${encodeURIComponent(evento.localizacao)}`;

  useEffect(() => {
    const interval = setInterval(criarConfete, 3000);
    return () => clearInterval(interval);
  }, []);

  function criarConfete() {
    const shapes = ["🎉", "🎊", "✨", "🎈", "🌟"];
    for (let i = 0; i < 5; i++) {
      const el = document.createElement("div");
      el.innerHTML = shapes[Math.floor(Math.random() * shapes.length)];
      el.style.cssText = `
        position: fixed; left: ${Math.random() * 100}vw; top: -20px;
        font-size: 20px; pointer-events: none; z-index: 1000;
        animation: fall 3s linear forwards;
      `;
      document.body.appendChild(el);
      setTimeout(() => el.remove(), 3000);
    }
  }

  useEffect(() => {
    const style = document.createElement("style");
    style.id = "confete-fall";
    if (!document.getElementById("confete-fall")) {
      style.textContent = `@keyframes fall { to { transform: translateY(100vh) rotate(360deg); opacity: 0; } }`;
      document.head.appendChild(style);
    }
    return () => document.getElementById("confete-fall")?.remove();
  }, []);

  const bgOverride = getBackground(layoutConfig);
  const imgWrapStyle = getCoverImageWrapperStyle(layoutConfig);
  const coverImageUrl = getResolvedCoverImageUrl(layoutConfig);
  const bannerMode = getBannerMode(layoutConfig);
  const customBannerUrl = layoutConfig?.bannerUrl;
  const showCustomBanner = bannerMode === "custom" && !!customBannerUrl;
  const showHowToGet = layoutConfig?.sections?.howToGet ?? true;
  const showAddress = (layoutConfig?.sections?.address ?? true) &&
    hasAddressContent(layoutConfig, evento.nomeEspaco, "pin");
  const showInfoSection = showHowToGet || showAddress;
  const showEventName = layoutConfig?.headerTitleVisible !== false;
  const showShortDescription = evento.descricao && evento.descricao.length <= 25;

  return (
    <div className={s.page} style={bgOverride ? { background: bgOverride } : undefined}>
      {/* Sparkles */}
      <div className={s.sparkles}>
        <div className={s.sparkle}>✨</div>
        <div className={s.sparkle}>⭐</div>
        <div className={s.sparkle}>✨</div>
        <div className={s.sparkle}>💫</div>
      </div>

      {/* Nuvens */}
      <div className={`${s.cloud} ${s.cloud1}`} />
      <div className={`${s.cloud} ${s.cloud2}`} />
      <div className={`${s.cloud} ${s.cloud3}`} />

      {/* Sol principal */}
      <div
        className={s.sunMain}
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/sol-cartoon.png)` }}
      />

      {/* Pequenos sóis */}
      <div className={`${s.sunSmall} ${s.sunSmall1}`} />
      <div className={`${s.sunSmall} ${s.sunSmall2}`} />
      <div className={`${s.sunSmall} ${s.sunSmall3}`} />
      <div className={`${s.sunSmall} ${s.sunSmall4}`} />
      <div className={`${s.sunSmall} ${s.sunSmall5}`} />

      <div className={s.container}>
        {/* Header com foto */}
        <div className={s.header}>
          <h1>Você é meu convidado</h1>
          {coverImageUrl && (
            <div className={s.photoFrame} style={imgWrapStyle || undefined}>
              <img
                src={coverImageUrl}
                alt={evento.nome}
                className={s.photoJulia}
              />
            </div>
          )}
        </div>

        {/* Nome + balão */}
        <div className={s.mainContent}>
          {(showEventName || showShortDescription) && (
            <div className={s.nameSection}>
              {showEventName && <h2 className={s.name}>{evento.nome}</h2>}
              {showShortDescription && (
              <div className={s.ageBalloon}>
                <span className={s.ageText}>{evento.descricao}</span>
              </div>
              )}
            </div>
          )}
          {evento.descricao && evento.descricao.length > 25 && (
            <p style={{ color: "white", fontSize: 14, textAlign: "center", padding: "8px 16px 16px", textShadow: "1px 1px 2px rgba(0,0,0,0.3)" }}>
              {evento.descricao}
            </p>
          )}
        </div>

        {showCustomBanner && (
          <div style={{ background: "rgba(255,255,255,0.18)", overflow: "hidden" }}>
            <img
              src={customBannerUrl}
              alt="Foto de capa"
              style={{ width: "100%", height: "auto", display: "block" }}
            />
          </div>
        )}

        {/* Data e localização */}
        {showInfoSection && (
          <div className={s.howToGet}>
            <div className={s.howToText}>Como Chegar</div>
            {showAddress && (
              <AddressLinkOriginal
                mapsUrl={mapsUrl}
                endereco={evento.localizacao}
                nomeEspaco={evento.nomeEspaco}
                layoutConfig={layoutConfig}
              />
            )}
            {showHowToGet && (
              <div className={s.dateTime}>
                <div className={s.datePart}>
                  <div className={s.day}>{dia}</div>
                  <div className={s.month} style={{ textTransform: "capitalize" }}>{mes}</div>
                </div>
                <div className={s.separator} />
                <div className={s.timePart}>
                  <div className={s.dayName} style={{ textTransform: "capitalize" }}>{diaSemana}</div>
                  <div className={s.time}>{hora}</div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Local + formulário RSVP */}
        <div className={s.venueInfo}>
          <div className={s.rsvpWrapper}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export const meta = { id: "original", label: "Original", emoji: "🌿", desc: "Verde e rosa, festivo e divertido" };
export const tema = {
  sectionBg:   "rgba(168,213,186,0.2)",
  recadoBg:    "rgba(244,166,205,0.18)",
  titulo:      { color: "#8b4513", textShadow: "none" },
  btnAdd:      { background: "linear-gradient(45deg,#7bc4a0,#a8d5ba)", color: "white" },
  itemBg:      "rgba(255,255,255,0.95)",
  numeroBg:    "#a8d5ba",
  numeroColor: "#8b4513",
  labelColor:  "#8b4513",
  inputExtra:  {},
  submit:      { background: "linear-gradient(45deg,#7bc4a0,#5daa8a)", boxShadow: "0 5px 15px rgba(93,170,138,0.45)", borderRadius: 25 },
};
